import { CustomReportConfig } from "@/component/common/report/reportConfigModel";
import { Input, Select } from "antd";
import React from "react";
import styled from "styled-components";
import { getContents } from "./alertMenuUtils";



const AlertMenuItemView = styled.div`
  &.alert-content{
    display: flex;
    align-items: center;
    >span:first-child{
      margin-left: 0;
    }
  }
  .error{
    display: none;
    font-size: 12px;
    color: red;
    position: absolute;
  }
  .input,.select{
    margin: 0 10px;
    width: 100px;
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .input input:out-of-range{
    color: red;
    &+.error{
      display: block;
    }
  }
` 


type AlertMenuItemProps = {
  menuItem: Required<CustomReportConfig>['alertMenu']['menu'][number]
  variable: Required<CustomReportConfig>['alertMenu']['variable']
  onChange?:(variableKey:string,value:string)=>void
  isEdit?: boolean
}





export const AlertMenuItem = (props: AlertMenuItemProps)=>{
  const { menuItem ,variable,isEdit,onChange = ()=>{}} = props

  const contents = React.useMemo(()=>{
    return getContents(menuItem.content)
  },[menuItem.content,variable])
  const renderContent = (contents:string[])=>{
    return contents.map((item,index)=>{
      let variableInfo = variable[item]
      if(!variableInfo){
        if(item == ''){
          return ''
        }
        return <span className="text" key={index} dangerouslySetInnerHTML={{__html:item.replaceAll(' ','\&nbsp;')}}></span>
      }
      if(!isEdit){
        let text = ''
        if(variableInfo.display_type == 'input'){
          text = variableInfo.key_value
        }
        if(variableInfo.display_type == 'select'){
          let select = variableInfo.drop_down_option?.find((option)=>option.value == variableInfo.key_value)
          if(select){
            text = select.label
          }
        }
        return <span  key={index}>{ text }</span>
      }
      if(variableInfo.display_type == 'input'){
        let rang = variableInfo.range
        return <span className="input">
          <Input value={variableInfo.key_value} onChange={(e)=>onChange(item,e.target.value)} type="number" max={rang?.max} min={rang?.min} ></Input>
          <span className="error">输入范围在{rang?.min}~{rang?.max}</span>
        </span>
      }
      if(variableInfo.display_type == 'select'){
        return <span className="select">
          <Select   value={variableInfo.key_value} onChange={(val)=>onChange(item,val)}  options={variableInfo.drop_down_option} ></Select>
        </span>
      }
      return <span></span>
    })
  }

  return  <AlertMenuItemView className="alert-content">
    { renderContent(contents) }
  </AlertMenuItemView>
}